import React, {useState,useEffect} from 'react';
import _ from 'lodash'

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from '../components/MUI-DGToolbar';
import CustomPagination from '../components/MUI-DGPagination';
import apiService from '../services/api';

function prettyTime(number){
    if(number < 10){
        return `0${number}`;
    }else{
        return number;
    }
}

function date(dateString){
    const d = new Date(dateString);
    return prettyTime(d.getDate())+"/"+prettyTime(d.getMonth()+1)+"/"+prettyTime(d.getFullYear())+" - "
        +prettyTime(d.getHours())+":"+prettyTime(d.getMinutes())+":"+prettyTime(d.getSeconds());
}

var now = new Date();
var d = now.getDate();
var m = now.getMonth() + 1;
var y = now.getFullYear();

var endDay = `${y}-${prettyTime(m)}-${prettyTime(d)}`;
var startDay;
if(m===1){
    startDay = `${y}-12-01`;
}else{
    startDay = `${y}-${prettyTime(m-1)}-01`;
}

function History(props){
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(()=>{
        async function fetchData(){
            try {
                setLoading(true);
                console.log('Fetching ratings with date range:', startDay, 'to', endDay);
                
                // Thử lấy tất cả ratings trước để debug
                const allRatingsResponse = await apiService.getRatings();
                console.log('All ratings response:', allRatingsResponse);
                
                // Lấy ratings theo khoảng thời gian
                const response = await apiService.getRatingsByDateRange(startDay, endDay);
                console.log('Date range ratings response:', response);
                
                if (!response.success || !response.data) {
                    setData([]);
                    return;
                }
                
                // Lấy thông tin staff để có tên và email
                const staffResponse = await apiService.getStaff();
                console.log('Staff response:', staffResponse);
                
                const staffMap = new Map();
                if (staffResponse.success && staffResponse.data) {
                    staffResponse.data.forEach(staff => {
                        staffMap.set(staff.staffId, staff);
                    });
                }
                
                // Kết hợp data ratings với thông tin staff
                const formattedData = response.data.map((rating, index) => {
                    console.log('Processing rating:', rating);
                    
                    const staff = staffMap.get(rating.staffId);
                    
                    // Rating đã là string, không cần chuyển đổi
                    const ratingText = rating.rating || 'Không xác định';
                    
                    return {
                        id: rating._id || `row-${index}`,
                        _id: rating._id,
                        displayName: rating.displayName || (staff ? staff.name : 'N/A'),
                        email: rating.email || (staff ? staff.email : ''),
                        mssv: rating.mssv || rating.userId || 'N/A',
                        rating: ratingText,
                        createAt: rating.createAt ? date(rating.createAt) : 'N/A',
                    };
                });
                
                console.log('Formatted data:', formattedData);
                setData(formattedData);
            } catch (err) {
                console.error('Error fetching history data:', err);
                setError('Lỗi khi tải dữ liệu lịch sử');
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    },[]);

    const columns = [
        { field: 'displayName', headerName: 'Nhân viên',    headerAlign: 'center', flex: 1},
        { field: 'email',       headerName: 'Email',        headerAlign: 'center', flex: 1},
        { field: 'mssv',        headerName: 'MSSV',         headerAlign: 'center', flex: 1,     align: "center"},
        { field: 'rating',      headerName: 'Đánh giá',     headerAlign: 'center', flex: 0.5,   align: "center"},
        { field: 'createAt',    headerName: 'Vào lúc',      headerAlign: 'center', flex: 2,     align: "center"},
    ];

    if (loading) {
        return (
            <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Đang tải dữ liệu...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                    <button 
                        className="btn btn-primary" 
                        onClick={() => window.location.reload()}
                    >
                        Thử lại
                    </button>
                </div>
            </div>
        );
    }

    return(
        <>
            <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                <div className="container p-3 shadow rounded">
                    <h3 className="pt-2 pb-2">LỊCH SỬ ĐÁNH GIÁ</h3>
                    <div style={{height: "680px", width: "100%"}}>
                        {(_.isEmpty(data))?
                        <div className=" h-100 d-flex justify-content-center">
                            <div className="align-self-center">Không có dữ liệu</div>
                        </div>:
                        <DataGrid
                            rows={data}
                            columns={columns}
                            pageSize={10}
                            checkboxSelection
                            getRowId={(row) => row.id}
                            components={{
                                Toolbar: CustomToolbar,
                                Pagination: CustomPagination,
                            }}
                            componentsProps={{
                                toolbar: { 
                                    fileName: "Lịch sử đánh giá" 
                                },
                            }}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'createAt', sort: 'desc' }],
                                },
                            }}
                        />}
                    </div>
                </div>
            </div>
        </>
    );    
}
export default History;